<div [@routerTransition]>
    <sub-header [title]="('Taxes' | localize) + ' ' + ('Details' | localize)" [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <tabset>
                    <tab heading="{{ 'BasicInformation' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Tax_Name">{{ l('Name') }} *</label>
                                    <input
                                        type="text"
                                        #Tax_Name="ngModel"
                                        id="Tax_Name"
                                        class="form-control"
                                        [(ngModel)]="tax.name"
                                        name="Name"
                                        minlength="0"
                                        maxlength="50"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Tax_Name"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Tax_TaxPercentage">{{ l('TaxPercentage') }}</label>
                                    <input
                                        type="number"
                                        #Tax_TaxPercentage="ngModel"
                                        id="Tax_TaxPercentage"
                                        class="form-control"
                                        [(ngModel)]="tax.taxPercentage"
                                        name="TaxPercentage"
                                    />
                                    <validation-messages [formCtrl]="Tax_TaxPercentage"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Tax_PurchaseSalesAttributes">{{ l('PurchaseSalesAttributes') }}</label>
                                    <input
                                        type="text"
                                        #Tax_PurchaseSalesAttributes="ngModel"
                                        id="Tax_PurchaseSalesAttributes"
                                        class="form-control"
                                        [(ngModel)]="tax.purchaseSalesAttributes"
                                        name="PurchaseSalesAttributes"
                                    />
                                    <validation-messages [formCtrl]="Tax_PurchaseSalesAttributes"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'TaxMapping' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th width="5%">#</th>
                                            <th width="20%">{{ l('Location') }}</th>
                                            <th width="20%">{{ l('Department') }}</th>
                                            <th width="20%">{{ l('Category') }}</th>
                                            <th width="25%">{{ l('Product') }}</th>
                                            <th width="5%">{{ l('Add') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of tax.taxMapping; let i = index">
                                            <td class="text-center">
                                                <button
                                                    (click)="removeItem(i)"
                                                    class="btn btn-danger d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    style="width: 30px; height: 30px"
                                                >
                                                    <i class="bi bi-dash fs-6 pe-0 fw-bold"></i>
                                                </button>
                                            </td>
                                            <td>
                                                <select
                                                    [(ngModel)]="item.locationId"
                                                    name="location{{ i }}"
                                                    class="form-select"
                                                    required
                                                >
                                                    <option value="null">{{ l('SelectALocation') }}</option>

                                            <option *ngFor="let item of allLocations" value="{{ item.id }}">
                                                {{ item.displayName }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <select [(ngModel)]="item.departmentId"
                                                name="departmentId{{i}}"
                                                class="form-select"
                                                required>
                                            <option value="null">{{ l('SelectADepartment') }}</option>

                                            <option  *ngFor="let item of allDepartments" value="{{ item.id }}">
                                                {{ item.displayName }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <select [(ngModel)]="item.categoryId"
                                                name="category{{i}}"
                                                class="form-select"
                                                required>
                                            <option value="null">{{ l('SelectACategory') }}</option>

                                            <option *ngFor="let item of allCategories" value="{{ item.id }}">
                                                {{ item.displayName }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <select [(ngModel)]="item.productId"
                                                name="product{{i}}"
                                                class="form-select"
                                                required>
                                            <option value="null">{{ l('SelectAProduct') }}</option>

                                                    <option *ngFor="let item of allProducts" value="{{ item.id }}">
                                                        {{ item.displayName }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td width="5%" class="text-center">
                                                <button
                                                    class="btn btn-success d-flex align-items-center justify-content-center p-0 rounded-circle"
                                                    (click)="addRow()"
                                                    style="width: 30px; height: 30px"
                                                >
                                                    <i class="bi bi-plus fs-6 p-0 fw-bold"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button
                        (click)="save()"
                        class="btn btn-primary me-2 float-right"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        *ngIf="!this.tax.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue float-right"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
